
import BaseModal from './BaseModal.vue'

export default {
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    teamData: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      memberData: {},
      showModal: false
    }
  },
  methods: {
    showMember(index) {
      let ind = index.split('_')[1]
      if (this.teamData[ind]) {
        this.memberData = {...this.teamData[ind]}
        this.toggleModal()
      }
    },
    toggleModal() {
      this.showModal = !this.showModal
    }
  }
}
